<template>
  <div class="space-y-3 rounded-[2.4rem] border border-black/10 bg-white/90 p-6 shadow-sm backdrop-blur">
    <div class="flex items-center justify-between text-[1.4rem] text-black">
      <span>{{ $t('Total') }}</span>
      <strong>{{ formatValue(totalDue) }}</strong>
    </div>
    <template v-if="hasDeposits">
      <div class="flex items-center justify-between text-[1.4rem] text-black">
        <span>{{ $t('Today you pay') }}</span>
        <strong>{{ formatValue(totalDueToday) }}</strong>
      </div>
      <p class="m-0 text-[1.2rem] text-[color:var(--gray)]">
        {{ $t('You pay {deposit} today as a deposit · the remaining {rest} is paid at the center', { deposit: formatValue(totalDueToday), rest: formatValue(totalRemainingAtCenter) }) }}
      </p>
    </template>
    <div v-if="!hasDeposits && hasActivePromoCodes" class="space-y-2 px-1">
      <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
        <input
          :value="promoCode"
          type="text"
          class="min-w-0 flex-1 rounded-xl border border-black/10 bg-white px-3 py-3 text-[1.4rem] focus:outline-none focus:ring-2 focus:ring-black/40"
          :placeholder="$t('Enter your coupon code')"
          @input="$emit('update:promoCode', $event.target.value)"
        />
        <AppButton class="w-full whitespace-nowrap sm:w-auto" :disabled="!promoCode || paymentLoading" @click="$emit('apply-promo')">
          {{ $t('Apply') }}
        </AppButton>
      </div>
      <div class="flex flex-col gap-1">
        <span v-if="promoApplied && promoDiscount" class="text-[1.2rem] text-green-700">
          {{ $t('Discount applied') }}: -{{ formatValue(promoDiscount) }}
        </span>
        <p v-if="promoError" class="text-[1.2rem] text-red-600">
          {{ promoError }}
        </p>
        <p v-if="promoSuccess" class="text-[1.2rem] text-green-700">
          {{ promoSuccess }}
        </p>
      </div>
    </div>
    <AppButton
      :block="true"
      :loading="paymentLoading"
      :disabled="!canConfirmPayment"
      @click="$emit('confirm-payment')"
    >
      {{ $t('Confirm and pay') }}
    </AppButton>
    <p v-if="paymentError" class="text-[1.2rem] text-red-600">
      {{ paymentError }}
    </p>
    <p v-if="paymentSuccess" class="text-[1.2rem] text-green-700">
      {{ paymentSuccess }}
    </p>
  </div>
</template>

<script>
import AppButton from '@/components/buttons/AppButton.vue';

export default {
  name: 'CheckoutPromoTotal',
  components: {
    AppButton,
  },
  props: {
    totalDue: {
      type: Number,
      default: 0,
    },
    hasDeposits: {
      type: Boolean,
      default: false,
    },
    hasActivePromoCodes: {
      type: Boolean,
      default: false,
    },
    totalDueToday: {
      type: Number,
      default: 0,
    },
    totalRemainingAtCenter: {
      type: Number,
      default: 0,
    },
    promoCode: {
      type: String,
      default: '',
    },
    promoApplied: {
      type: Boolean,
      default: false,
    },
    promoDiscount: {
      type: Number,
      default: 0,
    },
    promoError: {
      type: String,
      default: null,
    },
    promoSuccess: {
      type: String,
      default: null,
    },
    paymentLoading: {
      type: Boolean,
      default: false,
    },
    canConfirmPayment: {
      type: Boolean,
      default: false,
    },
    paymentError: {
      type: String,
      default: null,
    },
    paymentSuccess: {
      type: String,
      default: null,
    },
    formatAmount: {
      type: Function,
      default: null,
    },
  },
  emits: ['update:promoCode', 'apply-promo', 'confirm-payment'],
  methods: {
    formatValue(value) {
      if (typeof this.formatAmount === 'function') {
        return this.formatAmount(value);
      }
      return value === undefined || value === null ? '-' : String(value);
    },
  },
};
</script>
